<template>
  <div class="">
    <div class="bottom" id="buji-shop-card">
      <div class="fixed">
        <div class="b-left" @click="bindToggleToast">
          <div class="clock-wrapper">
            <div class="flag" v-show="data.length">{{ data.length }}</div>
            <img
              class="bottom-icon"
              id="shop-card-icon"
              :class="{ 'clock-gray': !data.length }"
              src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/db93efacb987dc568b68f7642d19b5e3.png"
              alt=""
            />
          </div>
          <div class="info-wrapper">
            <div class="info">{{
              data.length ? '已添加营养品' : '未添加营养品'
            }}</div>
            <div
              class="iconfont icon-black"
              v-show="data.length"
              :class="{ rotate: showPlanListToast }"
            ></div>
          </div>
        </div>
        <div
          class="create-btn"
          :class="{ 'disabled-create': !data.length }"
          @click="bindCreatePlan"
          v-clickBuried
          data-click-buried="CLICK_BUTTON_BUJILIEBIAO_OK"
        >
          {{ create ? '生成计划' : '确认添加' }}</div
        >
      </div>
    </div>
    <van-popup
      v-model="showPlanListToast"
      position="bottom"
      round
      class="plan-list-popup"
      :overlay-style="{ zIndex: 5000 }"
    >
      <ShopCardList :data="data" @del="bindDeleteBuji" />
    </van-popup>
  </div>
</template>

<script>
import ShopCardList from './plan-shopping-cart.vue'
export default {
  components: { ShopCardList },
  props: {
    data: {
      default: () => [],
      type: Array
    },
    create: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showPlanListToast: false
    }
  },
  created() {},
  methods: {
    bindToggleToast() {
      if (!this.data.length) {
        return
      }
      this.showPlanListToast = !this.showPlanListToast
    },
    bindDeleteBuji(item) {
      this.$emit('delete', item)
      if (!this.data.length) {
        this.showPlanListToast = false
      }
    },
    bindCreatePlan() {
      if (!this.data.length) {
        this.$toast('请先添加营养品')
        return
      }
      if (this.showPlanListToast) {
        this.showPlanListToast = false
        setTimeout(() => {
          this.$emit('submit')
        }, 300)
      } else {
        this.$emit('submit')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.plan-list-popup {
  z-index: 5001 !important;
}
.bottom {
  position: relative;
  z-index: 5002;
  background: #ffffff;
  box-shadow: 0px 0px 0px 0px #f2f2f2;
  padding: 8px 16px 0px;
  @include paddingBottom(6px);

  .fixed {
    height: 44px;
    border-radius: 22px;
    background: #ffffff;
    position: relative;
    z-index: 5000;
    display: flex;
    align-items: center;

    .b-left {
      border-radius: 22px 0px 0px 22px;
      background: #222426;
      height: 100%;
      flex: 1;
      flex-shrink: 0;
      overflow: visible;
      display: flex;
      align-items: flex-end;

      .clock-wrapper {
        margin-left: 10px;
        margin-right: 6px;
        width: 48px;
        height: 48px;
        position: relative;

        .flag {
          position: absolute;
          right: 0;
          top: 0;
          min-width: 16px;
          box-sizing: border-box;
          padding: 0px 4px;
          height: 16px;
          white-space: nowrap;
          text-align: center;
          line-height: 16px;
          background: #fc4444;
          border-radius: 50%;
          font-size: 10px;
          font-family: PingFangSC, PingFang SC;
          font-weight: bold;
          color: #ffffff;
        }
      }
    }

    .bottom-icon {
      width: 100%;
      height: 100%;
    }

    .clock-gray {
      filter: grayscale(100%);
    }

    .info-wrapper {
      margin-right: 4px;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      .info {
        font-size: 12px;
        font-family: PingFangSC, PingFang SC;
        color: #ffffff;
        line-height: 17px;
      }

      .iconfont {
        border-radius: 50%;
        box-sizing: border-box;
        width: 12px;
        height: 12px;
        font-size: 12px;
        background: #ffffff;
        border: 1px solid #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 18px;
        transition: 0.3s all ease;
        margin-left: 5px;
      }

      .detail {
        font-size: 10px;
        font-family: PingFangSC, PingFang SC;
        font-weight: bold;
        color: #fff;
        line-height: 14px;
      }
    }

    .rotate {
      transform: rotate(180deg);
    }

    .create-btn {
      width: 114px;
      height: 100%;
      background: linear-gradient(
        269deg,
        #6dfdc7 0%,
        #3edcf3 26%,
        #3cb6ff 100%
      );
      border-radius: 0px 26px 26px 0px;
      font-size: 16px;
      font-family: PingFangSC, PingFang SC;
      font-weight: bold;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .disabled-create {
      background: linear-gradient(
        269deg,
        #6dfdc7 0%,
        #3edcf3 26%,
        #3cb6ff 100%
      );
    }
  }
}
</style>
